import { useState } from "react"
import { FinanceKPIEntityType, KPIEntityRow } from "../types/FinanceKpiTypes"
import { useApi } from "utils"

export const KPI_STATIC_KEYS = [
    "key_description",
    "code_budget",
    "formula",
    "budget_id",
    "budget",
    "average"
  ] as const
  
  export const getLocationKeys = (item: any) => {
    return Object.keys(item).filter(
      (key) => !KPI_STATIC_KEYS.includes(key as any)
    )
  }


export const parseValue = (val: unknown): number => {
    if (val === null || val === undefined) return 0
    if (typeof val === "number") return val
    if (typeof val === "string") return Number(val)
    return 0
  }

export const mapToKPIEntityRow = (
    item: FinanceKPIEntityType
): KPIEntityRow => {
    const locationKeys = getLocationKeys(item)

    return {
    key_description: item.key_description,
    code_budget: item.code_budget,
    budget: item.budget,
    budget_id: item.budget_id,
    average: item.average,

    locations: locationKeys
        .sort()
        .map((key) => ({
        name: key,
        value: parseValue(item[key] ?? 0)
        }))
    }
}

export const KPIApis = [
  {
      category: "KEY KPI",
      code_budget: "KPI_RPE",
      key_description: "Revenue Per Entity",
      url: "analytic/revenue_per_entity/yearly"
  },
  {
    category: "KEY KPI",
    code_budget: "KPI_PPE",
    key_description: "Profit Per Entity",
    url: "analytic-finance/profit_per_entity/yearly"
  },
  {
    category: "KEY KPI",
    code_budget: "KPI_OMPE",
    key_description: "Operating Margin Per Entity",
    url: "analytic-finance/operating_margin_per_entity/yearly"
  },
  {
    category: "KEY KPI",
    code_budget: "KPI_CPE",
    key_description: "Cash Per Entity",
    url: "analytic-finance/cash_per_entity/yearly"
  },
  {
    category: "KEY KPI",
    code_budget: "KPI_FL",
    key_description: "Financial Leverage",
    url: "analytic-finance/financial_leverage/yearly"
  },
  {
    category: "KEY KPI",
    code_budget: "KPI_TETE",
    key_description: "Total Employee to Expenses",
    url: "analytic-finance/total_employee_to_expenses/yearly"
  },
  {
    category: "KEY KPI",
    code_budget: "KPI_TETR",
    key_description: "Total Employee to Revenue",
    url: "analytic-finance/total_employee_to_revenue/yearly"
  },
]


export function useFinanceKPIEntityList(
    year?: number,
    location_id?: string | ""
  ) {
    const api = useApi()
  
    const [data, setData] = useState<FinanceKPIEntityType[]>([])
    const [loadingKpi, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
  
    const fetchData = async () => {
        console.log(year);
      if (!year) return
  
      setLoading(true)
      setError(null)
  
      try {
        const params: any = { year }
  
        if (location_id && location_id !== "") {
          params.location_id = location_id
        }
  
        const responses = await Promise.all(
          KPIApis.map(async (item) => {
            try {
              const res = await api.get(item.url, { params })
  
              const payload = res.data?.payload?.[0]
                
                
              return {
                ...payload,
                key_description: item.key_description,
                code_budget: item.code_budget,
                budget_id: payload?.budget_id ?? null,
              }
            } catch {
              // fallback kalau API gagal
              return {
                key_description: item.key_description,
                code_budget: item.code_budget,
                budget_id: null,
                budget: null,
                average: null
              }
            }
          })
        )
  
        setData(responses)
      } catch (err: any) {
        setError(err?.response?.data?.message || "Failed to fetch data")
        setData([])
      } finally {
        setLoading(false)
      }
    }
  
    const refetchKPIEntity = () => fetchData()
  
    return {
      kpiEntityData: data,
      loadingKpi,
      error,
      refetchKPIEntity
    }
  }